import React, { ChangeEvent, ReactNode } from 'react';
import { type Control, useController } from 'react-hook-form';
import { AcuityTextField } from './AcuityTextField';

interface AcuityTextFieldControllerProps {
  readonly control: Control<any>;
  readonly helperText?: ReactNode;
  readonly id?: string;
  readonly interiorPost?: ReactNode;
  readonly interiorPre?: ReactNode;
  readonly name: string;
  readonly placeholder?: string;
  readonly rules?: object; // see https://react-hook-form.com/docs/useform/register#options
  readonly type?: string;
  readonly isDisabled?: boolean;
}

/**
 * To be used with React Hook Forms
 */
export const AcuityTextFieldController = ({
  control,
  helperText,
  id,
  interiorPost,
  interiorPre,
  isDisabled,
  name,
  placeholder,
  rules,
  type,
}: AcuityTextFieldControllerProps): React.JSX.Element => {
  const {
    field: { disabled, ref, onBlur, onChange, value },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    disabled: isDisabled,
  });
  return (
    <>
      <AcuityTextField
        inputProps={{
          id,
          name,
          disabled,
          ref,
          onBlur,
          value,
          placeholder,
          type,
          onChange: (v: string, e: ChangeEvent<HTMLInputElement>) => {
            onChange(e);
          },
        }}
        helperText={helperText}
        interiorPost={interiorPost}
        interiorPre={interiorPre}
        errorText={error && <>{error.message}</>}
      />
    </>
  );
};
